import { cloneDeep, remove, findIndex } from "lodash";
import {
  CREATE_GRADEBOOK_CATEGORIES_SUCCESS,
  CREATE_GRADEBOOK_ITEMS_SUCCESS,
  DELETE_FINAL_GRADES_SUCCESS,
  DELETE_GRADEBOOK_CATEGORIES_SUCCESS,
  DELETE_GRADEBOOK_ITEMS_SUCCESS,
  GET_ALL_DISCUSSION_CATEGORY_WEIGHT_SUCCESS,
  GET_ALL_DROPBOX_CATEGORY_WEIGHT_SUCCESS,
  GET_ALL_GRADBOOK_DROPDOWN_SUCCESS,
  GET_ALL_GRADEBOOK_CATEGORIES_SUCCESS,
  GET_ALL_GRADEBOOK_ITEMS_SUCCESS,
  GET_ALL_GRADEBOOK_ITEM_GROPU_SUCCESS,
  GET_CATEGORIES_DROPDOWN,
  GET_FINALIZE_STUDENTS,
  GET_FINAL_GRADES_SUCCESS,
  GET_GRADEBOOK_COURSE_ATTENDEES_SUCCESS,
  GET_GRADEBOOK_LIST_DROPDOWN,
  GET_GRADEBOOK_STUDENT_GRADE_SUCCESS,
  GET_GRADE_BOOK_TEST_ITEM_SUCCESS,
  GET_GRADE_UTEM_FOR_FULL_GRADEBOOK_SUCCESS,
  RESET_CATEGORIES_DROPDOWN,
  RESET_DISCUSSION_CATEGORY_WEIGHT,
  RESET_DROPBOX_CATEGORY_WEIGHT,
  RESET_GRADEBOOK_ITEMS,
  RESET_GRADEBOOK_STUDENT_GRADE,
  UPDATE_FINAL_GRADES_SUCCESS,
  UPDATE_FULL_GRADEBOOK_SUCCESS,
  UPDATE_GRADEBOOK_CATEGORIES_SUCCESS,
  UPDATE_GRADEBOOK_ITEMS_SUCCESS,
} from "../constants";

export const initialState = {
  categories: undefined,
  items: undefined,
  categoriesDropdown: undefined,
  dropboxWeightData: undefined,
  discussionWeightData: undefined,
  gradeItemDropdown: undefined,
  gradebookItemGroupDetails: undefined,
  gradebookStudentGrade: undefined,
  courseUserList: [],
  cousreUserLoading: false,
  finalGrades: undefined,
  gradeTest: undefined,
  allGradebook: undefined,
  fullGradebook: undefined,
  finalizeStudents: [],
};
export const GradebookReducer = (state = initialState, action) => {
  //switch between action.type
  switch (action.type) {
    case GET_ALL_GRADEBOOK_CATEGORIES_SUCCESS: {
      return {
        ...state,
        categories: action.payload,
      };
    }
    case GET_GRADE_BOOK_TEST_ITEM_SUCCESS: {
      return {
        ...state,
        gradeTest: action.payload,
      };
    }
    case CREATE_GRADEBOOK_CATEGORIES_SUCCESS: {
      const tempcategories = cloneDeep(state.categories);
      tempcategories.data.splice(0, 0, action.payload);
      return {
        ...state,
        categories: tempcategories,
      };
    }
    case GET_GRADEBOOK_LIST_DROPDOWN: {
      return {
        ...state,
        gradeItemDropdown: action.payload,
      };
    }
    case UPDATE_GRADEBOOK_CATEGORIES_SUCCESS: {
      const tempcategories = cloneDeep(state.categories);
      const index = findIndex(
        tempcategories.data,
        (obj) => obj._id === action.payload._id
      );

      if (index !== -1) {
        tempcategories.data[index] = action.payload;
      }
      return {
        ...state,
        categories: tempcategories,
      };
    }

    ///////////////////////////////// new create///////////////////////
    case GET_ALL_GRADBOOK_DROPDOWN_SUCCESS: {
      return {
        ...state,
        allGradebook: action.payload,
      };
    }
    case DELETE_GRADEBOOK_CATEGORIES_SUCCESS: {
      const tempcategories = cloneDeep(state.categories);
      remove(tempcategories.data, (obj) => obj._id === action.payload);
      return {
        ...state,
        categories: tempcategories,
      };
    }

    // Items
    case GET_ALL_GRADEBOOK_ITEMS_SUCCESS: {
      return {
        ...state,
        items: action.payload,
      };
    }
    case GET_GRADE_UTEM_FOR_FULL_GRADEBOOK_SUCCESS: {
      return {
        ...state,
        fullGradebook: action.payload,
      };
    }
    case CREATE_GRADEBOOK_ITEMS_SUCCESS: {
      const tempcategories = cloneDeep(state?.items);
      tempcategories.data.splice(0, 0, action.payload);
      return {
        ...state,
        items: tempcategories,
      };
    }
    // case ADD_DISCUSSION_FOR_POST: {
    //
    //   const tempAddDetails = cloneDeep(state?.discussionSinglePost);
    //
    //   tempAddDetails?.splice(0, 0, action.payload);
    //   return {
    //     ...state,
    //     discussionSinglePost: tempAddDetails,
    //   };
    // }
    case UPDATE_GRADEBOOK_ITEMS_SUCCESS: {
      const tempcategories = cloneDeep(state.items);
      const index = findIndex(
        tempcategories.data,
        (obj) => obj._id === action.payload._id
      );

      if (index !== -1) {
        tempcategories.data[index] = action.payload;
      }
      return {
        ...state,
        items: tempcategories,
      };
    }

    case DELETE_GRADEBOOK_ITEMS_SUCCESS: {
      const tempcategories = cloneDeep(state.items);
      remove(tempcategories.data, (obj) => obj._id === action.payload);
      return {
        ...state,
        items: tempcategories,
      };
    }
    case RESET_GRADEBOOK_ITEMS: {
      return {
        ...state,
        items: "",
      };
    }
    case GET_CATEGORIES_DROPDOWN: {
      return {
        ...state,
        categoriesDropdown: action.payload,
      };
    }
    case RESET_CATEGORIES_DROPDOWN: {
      return {
        ...state,
        categoriesDropdown: "",
      };
    }
    case GET_ALL_DROPBOX_CATEGORY_WEIGHT_SUCCESS: {
      return {
        ...state,
        dropboxWeightData: action.payload,
      };
    }

    case GET_GRADEBOOK_COURSE_ATTENDEES_SUCCESS:
      return {
        ...state,
        courseUserList: action.payload,
        cousreUserLoading: false,
      };

    case GET_ALL_DISCUSSION_CATEGORY_WEIGHT_SUCCESS: {
      return {
        ...state,
        discussionWeightData: action.payload,
      };
    }
    case RESET_DROPBOX_CATEGORY_WEIGHT: {
      return {
        ...state,
        dropboxWeightData: "",
      };
    }
    case RESET_DISCUSSION_CATEGORY_WEIGHT: {
      return {
        ...state,
        discussionWeightData: "",
      };
    }
    case GET_ALL_GRADEBOOK_ITEM_GROPU_SUCCESS: {
      return {
        ...state,
        gradebookItemGroupDetails: action.payload,
      };
    }
    case GET_GRADEBOOK_STUDENT_GRADE_SUCCESS: {
      return {
        ...state,
        gradebookStudentGrade: action.payload,
      };
    }
    case UPDATE_FULL_GRADEBOOK_SUCCESS: {
      const tempMailDetails = cloneDeep(state.gradebookStudentGrade);
      const index = findIndex(
        tempMailDetails.data,
        (obj) => obj._id === action.payload._id
      );

      if (index !== -1) {
        tempMailDetails.data[index] = action.payload;
      }

      return {
        ...state,
        gradebookStudentGrade: tempMailDetails,
      };
    }
    case RESET_GRADEBOOK_STUDENT_GRADE: {
      return {
        ...state,
        gradebookStudentGrade: "",
      };
    }
    case GET_FINAL_GRADES_SUCCESS: {
      return {
        ...state,
        finalGrades: action.payload,
      };
    }
    case UPDATE_FINAL_GRADES_SUCCESS: {
      const tempcategories = {};
      tempcategories.data = action.payload;
      tempcategories.count = action.payload.length;
      return {
        ...state,
        finalGrades: tempcategories,
      };
    }
    case DELETE_FINAL_GRADES_SUCCESS: {
      return {
        ...state,
        finalGrades: undefined,
      };
    }

    case GET_FINALIZE_STUDENTS:
      return {
        ...state,
        finalizeStudents: action.payload,
      };
    default:
      return state;
  }
};
